var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountFormContactDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    fill: "none",
    focusable: "false",
    height: 20,
    stroke: "none",
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5919 17.999C16.5919 14.3838 13.6612 11.4531 10.0459 11.4531C6.43069 11.4531 3.5 14.3838 3.5 17.999H4.84925C4.84925 15.129 7.17586 12.8024 10.0459 12.8024C12.916 12.8024 15.2426 15.129 15.2426 17.999H16.5919Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.0429 10.6324C12.4267 10.6324 14.3591 8.70002 14.3591 6.31622C14.3591 3.93242 12.4267 2 10.0429 2C7.65906 2 5.72656 3.93239 5.72656 6.31622C5.72656 8.70005 7.65906 10.6324 10.0429 10.6324ZM10.0429 3.34928C11.6815 3.34928 13.0098 4.67763 13.0098 6.31626C13.0098 7.95488 11.6815 9.28323 10.0429 9.28323C8.40415 9.28323 7.07574 7.9549 7.07574 6.31626C7.07574 4.67761 8.40415 3.34928 10.0429 3.34928Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountFormContactDetailsIcon);
export default __webpack_public_path__ + "static/media/AccountFormContactDetailsIcon.36f6e5f0205c3bb5504e0863acbb93dd.svg";
export { ForwardRef as ReactComponent };